<template>
  <main v-if="kql.page?.content?.content" class="home">
    <LayoutBlock :block='block' v-for='block in JSON.parse(kql.page?.content?.content)' :context='kql.page' />
  </main>
</template>

<script setup>
  import { useStore } from '@/KQL.js'
  const kql = useStore();
  const children = computed(()=>pageFromPath(kql.page.uid, kql?.pages)?.children);
</script>

<style scoped>
main {
    padding: var(--top-padding-moderate) clamp(5px, 9rem, 5%);
    margin: auto;
    box-sizing: border-box;
}

:deep(div.textblock) {
  text-indent: 0;
  margin-left: auto;
  margin-right: auto;
}

:deep(h1), :deep(h2), :deep(h3) {
  margin-bottom: 0.25em;
  text-align: left;
  margin-left: 1rem;
  margin-right: auto;
}

:deep(div.textblock p) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: calc(100% - 2rem);
  text-align: left;
}
</style>
